import React from 'react';

const initialState = {
	settings: {} as WebSettings,
	isInitializing: true,
};
const SettingsContext = React.createContext(initialState);

export default SettingsContext;